import styled from "styled-components";


export const LogoContainer = styled.div`
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid ${({ theme }) => theme.colors['grey-300']};
  padding: 8px 16px;
`

export const LogoImg = styled.div`
  display: flex;
  border-radius:50%;
`

export const LogoText = styled.div<{ $fontSize: string }>`
  font-size: ${({ $fontSize }) => $fontSize};
`
